<template>
  <!-- @todo -->
  <div>
    <veaDialog
      :title="'批量导入附件'"
      :confirm-button-text="'上传'"
      class="batch_image_import_dialog"
      :show.sync="show"
    >
      <!-- 外部弹窗内容部分 -->
      <!-- ps:这里要用v-show，否则无法调用 importExcel() 事件 -->
      <el-upload
        ref="upload"
        class="upload-demo"
        drag
        action
        multiple
        :file-list="fileList"
        :http-request="customUpload"
        :on-change="handleChange"
        :on-remove="handleRemove"
        :before-remove="removeBefore"
        :auto-upload="false"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          {{ '将文件拖到此区域，或' }}<em>{{ '点击上传' }}</em>
        </div>
      </el-upload>
      <!-- <div class="msg">
        <p class="text" style="color:red; text-align:left">
          {{
            '附件的命名格式必须为：附件格式名称.jpg ，例如：身份证.jpg （文件后缀不限）'
          }}
        </p>
      </div> -->
      <template slot="footer-left">
        <el-progress
          :text-inside="true"
          :stroke-width="24"
          :percentage="percentage"
          status="success"
          style="width: 420px;"
        ></el-progress>
        <el-checkbox v-model="keepOriginalName">{{
          '保留原文件名'
        }}</el-checkbox>
      </template>
      <template slot="footer-right">
        <el-button plain v-preventReClick @click="show = false">{{
          '退出'
        }}</el-button>
        <el-button
          type="primary"
          :disabled="!fileList.length > 0"
          v-preventReClick
          @click="closeDialog"
          >{{ '确定' }}</el-button
        >
      </template>
    </veaDialog>

    <!-- 系统提示 -->
    <systemTipsDialog
      :show.sync="systemTipsShow"
      :tips="errorMsg"
      :close="sysTipDialogClose"
    />
  </div>
</template>
<script>
import systemTipsDialog from '@components/common/systemTipsDialog'
import { createGguid, drag } from '@/assets/js/pubMethods'
// import { upLoadCustomFile, checkFileNameIsCorrect } from '@/api/api.js'
export default {
  components: { systemTipsDialog },
  // directives: {
  //   // 指令
  //   dialogDrag: {
  //     bind: drag // 实现拖拽
  //   }
  // },
  props: {
    close: {
      // 通知 toolbar.vue 清空激活的组件 跟 watch 中的 show 一并使用
      type: Function,
      default: () => {
        console.error(`**${this.active}模块未设置close方法**`)
      }
    }
  },
  data() {
    return {
      errorMsg: '', // 系统错误提示
      systemTipsShow: false, // 系统提示框 弹框
      fileList: [],
      show: false, // 测试专用，用完请改回false
      userInfo: JSON.parse(sessionStorage.getItem('userInfo')) || {}, // 用户登录信息
      percentage: 0,
      keepOriginalName: true
    }
  },
  watch: {
    show(n) {
      if (!n) {
        this.percentage = 0
      }
    }
  },
  created() {
    // window.T = this;
  },

  mounted() {
    // window.tableImport = this;
  },
  methods: {
    // 自定义上传事件
    customUpload() {},
    // 写入系统提示语
    writeSysTips(data) {
      this.systemTipsShow = true
      data.forEach(item => {
        this.errorMsg += item.res + '\n'
      })
    },
    // 关闭系统提示弹窗
    sysTipDialogClose() {
      this.systemTipsShow = false
      this.errorMsg = ''
    },
    //监控上传文件列表
    handleChange(file, fileList) {
      let existFile = fileList
        .slice(0, fileList.length - 1)
        .find(f => f.name === file.name)
      if (existFile) {
        this.$message.error('当前文件已经存在!')
        fileList.pop()
      }
      this.fileList = fileList
    },
    // 移除
    handleRemove(file, fileList) {
      this.fileList = fileList
      //  console.log(fileList,'执行了')
    },
    // 移除前方法
    removeBefore(file, fileList) {
      return this.$confirm(`${'确定移除'} ${file.name}？`)
    },
    // 弹窗关闭前
    async closeDialog() {
      let hasImp = 0
      let fuckLength = this.fileList.length
      let errorData = []
      if (this.fileList.length > 0) {
        for (const file of this.fileList) {
          // 先判断文件名是否符合格式
          let params = {
            moduleno: this.moduleNo,
            filename: file.name,
            username: this.userInfo.username
          }
          let reuslts = []
          reuslts = await this.checkFileName(params)
          let obj = {
            moduleno: this.moduleNo,
            upflag: 2,
            autoid: 0,
            uploadpath: this.userInfo.attachfilepath,
            username: this.userInfo.username,
            cusfilename: '',
            packagetype: '',
            file: file.raw
          }
          if (reuslts.length > 0) {
            if (reuslts[0].info) {
              hasImp = hasImp + 1
              this.percentage = parseInt((hasImp / fuckLength) * 100)
              errorData.push({ res: reuslts[0].info })
              continue
            } else {
              obj.autoid = reuslts[0].autoid
              if (this.keepOriginalName) {
                obj.cusfilename = file.name.substring(
                  0,
                  file.name.lastIndexOf('.')
                )
              } else {
                obj.cusfilename = reuslts[0].filename.substring(
                  0,
                  reuslts[0].filename.lastIndexOf('.')
                )
              }
              // obj.packagetype = reuslts[0].filename.substring(0, reuslts[0].filename.lastIndexOf("."))
            }
          }
          // console.log(obj, 'uploadobj');
          upLoadCustomFile(obj).then(res => {
            hasImp = hasImp + 1
            this.percentage = parseInt((hasImp / fuckLength) * 100)
            if (hasImp == fuckLength) {
              // 刷新列表
              this.$emit('getappendix')
              this.fileList = []
              this.$message.success('导入成功！')
              setTimeout(() => {
                this.show = false
              }, 200)
            }
            if (res === 'OK') {
            } else {
              errorData.push({ res: file.name + '_' + res })
            }
          })
        }
        if (errorData.length > 0) {
          this.writeSysTips(errorData)
        }
      }
    },
    // 根据工号获取empid值
    async checkFileName(val) {
      let result = []
      await checkFileNameIsCorrect(val).then(res => {
        result = res.data
      })
      return result
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/styles/mixin.scss';

.el-dialog__wrapper.batch_image_import_dialog {
  color: $font-color;
  /deep/.el-dialog {
    @include wh(920px, 580px);

    box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);

    // 表头
    .el-dialog__header {
    }
    // 主体
    .el-dialog__body {
      height: calc(100% - 130px) !important;
      padding: 20px 20px 0 20px;
      // flex: 1;
      overflow: auto;
      // display: flex;

      @include wh(100%, 100%);

      .upload-demo {
        display: flex;
        height: 86%;
        margin-bottom: 20px;
        .el-upload {
          width: 60%;
          height: 100%;
          margin-right: 20px;
          .el-upload-dragger {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            .el-upload__text {
              margin-bottom: 20px;
            }
          }
        }
        .el-upload-list {
          flex: 1;
          height: 100%;
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
          box-sizing: border-box;
          overflow: auto;
          li {
            a {
              padding-left: 8px;
              width: 100%;
            }
          }
        }
      }
    }
    // 尾部
    .el-dialog__footer {
      .footer_left {
        display: flex;
        align-items: center;
        .el-checkbox {
          margin-left: 20px;
        }
      }
    }
  }
}
</style>
